import { TableColumnsType } from "antd";
import React from "react";
import ReusableTable from "../../../../../../global components/Table/Table";
import NoData from "../../../../../../global components/Table/NoData/NoData";
import { PieChart } from "../../../../../../global components/Icons/PieChart";
import { PaginatedComplianceReportType } from "../../../../../../libs/Utils/Types/Reports";
import dayjs from "dayjs";
import Unauthorised from "../../../../../../global components/Unauthorised";
type ColumnsType = {
  serialNumber: number;
  key: number;
  date: string;
  spamUser: number;
  failedKyc: number;
  totalRevoked: number;
};
type PropType = {
  isLoading: boolean;
  dataSource: PaginatedComplianceReportType["data"];
  unauthorized: boolean | { title: string; message: string };
};
function ComplianceReportTable({
  dataSource,
  isLoading,
  unauthorized,
}: PropType) {
  const columns: TableColumnsType<ColumnsType> = [
    {
      title: "S/N",
      dataIndex: "serialNumber",
      key: "serialNumber",
      render: (serialNumber: number) => <span>{serialNumber}</span>,
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      render: (date: string) => <span>{date}</span>,
    },
    {
      title: "Suspended User",
      dataIndex: "spamUser",
      key: "spamUser",
      render: (spamUser: number) => <span>{spamUser}</span>,
    },
    {
      title: "Numbers Revoked (Inactivity)",
      dataIndex: "totalRevoked",
      key: "totalRevoked",
      render: (totalRevoked: number) => <span>{totalRevoked}</span>,
    },
    {
      title: "Failed KYC Cases",
      dataIndex: "failedKyc",
      key: "failedKyc",
      render: (failedKyc: string) => <span>{failedKyc}</span>,
    },
  ];
  const data: ColumnsType[] =
    dataSource.map((item, index) => ({
      date: dayjs.utc(item.date).local().format("MMM DD, YYYY"),
      failedKyc: item.failedKycCount,
      spamUser: item.suspendedUserCount,
      key: index + 1,
      serialNumber: index + 1,
      totalRevoked: item.revokedNumberCount,
    })) ?? [];
  return (
    <ReusableTable
      columns={columns}
      dataSource={data}
      loading={isLoading}
      noDataComponent={
        unauthorized ? (
          typeof unauthorized === "boolean" ? (
            <Unauthorised />
          ) : (
            <Unauthorised error={unauthorized} />
          )
        ) : (
          <NoData
            Message="No compliance report found"
            subMessage=""
            icon={<PieChart height={32} width={32} />}
          />
        )
      }
    />
  );
}

export default ComplianceReportTable;
